import cnt from '@/api/cnt'

// initial state
const state = {
    cntList: [],
    cntReportList: []
}


// getters
const getters = {

}

// actions
const actions = {
    getCntList({ commit }) {
        cnt.getList(response => {
            commit('setCntList', response.list);
        })
    },
    getReportList({ commit }, request) {
        cnt.getReportList(response => {
            commit('setCntReportList', response.list);
            console.log(response.list)
        }, request)
    },
}



// mutations
const mutations = {
    setCntList(state, cntList) {
        state.cntList = cntList
    },
    setCntReportList(state, cntReportList) {
        state.cntReportList = cntReportList
    },
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}